export default __webpack_public_path__ + "static/gantmodern-bold-02ab29d624154c7e9315aceb6978f674.woff";